import { Box, Col, FlexRow } from '@edreamsodigeo/prisma-design-system';
import React from 'react';
import { StepHeading } from './StepHeading';
import { StepTitle } from './StepTitle';
import PropTypes from 'prop-types';
import { Mobile } from '@edreamsodigeo/frontend-core';

export const ChronologyContent = ({
  heading,
  title,
  children,
  active = false,
  pill = <></>,
  nonPrimePrice = null,
}) => {
  return (
    <Box pl="2x_small" pb="1x_big">
      <Box pb="1x_small" pt="2x_small">
        <StepHeading active={active}>{heading}</StepHeading>
      </Box>
      <Box>
        <FlexRow flexDirection="row" justifyContent="space-between">
          <Col flex="3 1 0%">
            <StepTitle>{title}</StepTitle>
          </Col>
          <Col>
            <Col>
              <Mobile>{nonPrimePrice}</Mobile>
            </Col>
          </Col>
          <Col>
            <Box mr="base">
              <Mobile>{pill}</Mobile>
            </Box>
          </Col>
        </FlexRow>
      </Box>
      {children}
    </Box>
  );
};

ChronologyContent.propTypes = {
  heading: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
};
